import { 
  AUTHENTICATING_USER_REQUEST, AUTHENTICATING_USER_SUCCEDDED, AUTHENTICATING_USER_FAILED, 
  FETCHING_SSO_URL_REQUEST, FETCHING_SSO_URL_SUCCEEDED, FETCHING_SSO_URL_FAILED, SSO_AUTHENTICATION_FAILED, 
  LOGOUT_USER,
  FETCHING_USER_PROFILE, FETCHING_USER_PROFILE_SUCCEEDED, FETCHING_USER_PROFILE_FAILED,
  USER_REGISTRATION_REQUEST, USER_REGISTRATION_SUCCEDDED, USER_REGISTRATION_FAILED
} from 'constants/actionTypes.jsx';

import _ from 'lodash';

const initialState = {
  authentication: {
    authenticating: false,
    authenticated: false,
    error: null,
  },
  changePassword: {
    error: [],
    recoveryError: null,
    loading: false,
    success: false,
    changing: false
  },
  me: null,
  forgotPassword:{
    loading: false,
    error: null
  },
  registration: {
    loading: false,
    item: null,
    success: false,
    resending: false,
    resentEmail: false
  },
  sso: {
    loading: false,
    signinWithPassword: false,
    item: null
  },
  updating: false
}

function usersReducer(state = initialState, action) {
  switch (action.type) {
    case USER_REGISTRATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        registration:{
          ...state.registration,
          loading: true,
          item: null,
          error: null
        }
      })
    case USER_REGISTRATION_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        registration:{
          ...state.registration,
          loading: false,
          success: true,
          item: action.payload
        }
      })
    case USER_REGISTRATION_FAILED:
      var error = action.payload.response.data.errors[0];
      return Object.assign({}, state, {
        ...state,
        registration:{
          ...state.registration,
          loading: false,
          item: null,
          error: error.message
        }
      })

    default:
      return state
  }
}

export { usersReducer };